const C = require("../constants");

const showModalInvoiceByEmail = (modal) => {
    return {
        type: C.SHOW_MODAL_INVOICE_BY_EMAIL,
        modal
    }
};

export {showModalInvoiceByEmail};


// WEBPACK FOOTER //
// ./src/actions/SendInvoiceByEmailActions.js